export { default } from "./DevelopmentOpportunitiesBar";
